import { useEffect, useState } from "react";
import { Button, TextField, Card, CardContent, FormControl, InputLabel, Select, MenuItem, IconButton } from "@mui/material";
import MDBox from "components/MDBox";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';
import MDButton from "components/MDButton";

const formList = {
    group_id: null,
    condition_type_id: null,
    condition_group_id: null,
    parameter_id: null,
    comparison_operator_id: null,
    alert_type_id: null,
    value: ''
}

const MultiDataForm = ({ setChildFormData, childFormData = null, listData }) => {
    const [formData, setFormData] = useState(childFormData ? childFormData : [JSON.parse(JSON.stringify(formList))]);

    const handleChange = (index, event) => {
        const { name, value } = event.target;
        const newFormData = [...formData];
        newFormData[index][name] = value;

        if (name === 'group_id') {
            // Find the first occurrence of the same group_id in the formData
            const existingEntry = newFormData.find((item, idx) => item.group_id === value && idx !== index);

            if (existingEntry) {
                // Copy condition_type_id and condition_group_id from the existing entry
                newFormData[index].condition_type_id = existingEntry.condition_type_id;
                newFormData[index].condition_group_id = existingEntry.condition_group_id;
            }
        }

        if(name == 'parameter_id'){
            if(value == 2){
                newFormData[index].alert_type_id = '';
            } else {
                newFormData[index].alert_type_id = null;
            }
        }

        setFormData(newFormData);
    };

    const addMoreFields = () => {
        let emptyFormData = JSON.parse(JSON.stringify(formList));
        setFormData([...formData, emptyFormData]);
    };

    const duplicateFields = (index) => {
        let duplicateData = formData[index]
        let duplicateFormData =JSON.parse(JSON.stringify(duplicateData))
        setFormData([...formData, duplicateFormData]);
    }

    const handleRemove = (index) => {
        if (formData.length > 1) {
            setFormData(formData.filter((_, i) => i !== index));
        }
    };

    useEffect(() => {
        setChildFormData(formData);
    }, [formData]);


    return (
        <Card >
            <CardContent>
                <MDBox >
                    {formData.map((data, index) => (
                        <div key={index} style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                            <FormControl fullWidth margin="normal">
                                <InputLabel>Group ID</InputLabel>
                                <Select label="Group ID" name="group_id" value={data.group_id ?? ''} onChange={(e) => handleChange(index, e)} sx={{ height: '40px' }} required>
                                    {
                                        formData.length && formData.map((elm, key) => (
                                            <MenuItem key={key} value={key + 1}>{key + 1}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                            <FormControl fullWidth margin="normal">
                                <InputLabel>Condition Type</InputLabel>
                                <Select label="Condition Type" name="condition_type_id" value={data.condition_type_id ?? ''} onChange={(e) => handleChange(index, e)} sx={{ height: '40px' }} required>
                                    {
                                        listData?.route_condition_types?.length && listData?.route_condition_types?.map((elm) => (
                                            <MenuItem key={elm.condition_type_id} value={elm.condition_type_id}>{elm.condition_name}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                            <FormControl fullWidth margin="normal">
                                <InputLabel>Condition Group</InputLabel>
                                <Select label="Condition Group" name="condition_group_id" value={data.condition_group_id ?? ''} onChange={(e) => handleChange(index, e)} sx={{ height: '40px' }} required>
                                    <MenuItem key={'AND'} value={'AND'}>AND</MenuItem>
                                    <MenuItem key={'OR'} value={'OR'}>OR</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl fullWidth margin="normal">
                                <InputLabel>Parameter</InputLabel>
                                <Select label="Config Parameter" name="parameter_id" value={data.parameter_id ?? ''} onChange={(e) => handleChange(index, e)} sx={{ height: '40px' }} required>
                                    {
                                        listData?.route_config_parameter?.length && listData?.route_config_parameter?.map((elm) => (
                                            <MenuItem key={elm.parameter_id} value={elm.parameter_id}>{elm.parameter_name}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                            <FormControl fullWidth margin="normal">
                                <InputLabel>Comparison</InputLabel>
                                <Select label="Comparison" name="comparison_operator_id" value={data.comparison_operator_id ?? ''} onChange={(e) => handleChange(index, e)} sx={{ height: '40px' }} required>
                                    {
                                        listData?.comparison_operator?.length && listData?.comparison_operator?.map((elm) => (
                                            <MenuItem key={elm.id} value={elm.id}>{elm.label}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                            <FormControl fullWidth margin="normal" readOnly={data.alert_type_id == null}>
                                <InputLabel>Alert Type</InputLabel>
                                <Select label="Alert Type" name="alert_type_id" value={data.alert_type_id ?? ''} onChange={(e) => handleChange(index, e)} sx={{ height: '40px' }} readOnly={data.alert_type_id == null}>
                                    {
                                        listData?.alert_type?.length && listData?.alert_type?.map((elm) => (
                                            <MenuItem key={elm.alert_type_id} value={elm.alert_type_id}>{elm.type_name}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                            <TextField
                                label="Value"
                                name="value"
                                value={data.value}
                                onChange={(e) => handleChange(index, e)}
                                required
                                margin="normal"
                                fullWidth
                            />
                            <IconButton onClick={() => duplicateFields(index)} color="primary">
                                <ContentCopyIcon />
                            </IconButton >
                            <IconButton onClick={() => handleRemove(index)} color="error">
                                <CloseIcon />
                            </IconButton>
                        </div>
                    ))}
                    <MDButton onClick={addMoreFields} variant="outlined" sx={{ mt: 1 }}>
                        Add More
                    </MDButton>
                </MDBox>
            </CardContent>
        </Card>
    );
};

export default MultiDataForm;
